import React from 'react';
import { TextInput } from '../ui';

function SeasonEditView({
  seasonEditForm,
  setSeasonEditForm,
  saveSeasonEdit,
  setView
}) {
  return (
    <section className="card auth-card" style={{ marginBottom: "40px" }}>
      <h2 className="section-title">Edit Season</h2>
      <form onSubmit={saveSeasonEdit} className="auth-form">
        <TextInput
          label="Season name"
          value={seasonEditForm.name}
          onChange={(v) => setSeasonEditForm((s) => ({ ...s, name: v }))}
        />
        <TextInput
          label="Team (optional)"
          value={seasonEditForm.team}
          onChange={(v) => setSeasonEditForm((s) => ({ ...s, team: v }))}
          placeholder="e.g., Lincoln High School"
        />
        <TextInput
          label="Year (optional)"
          value={seasonEditForm.year}
          onChange={(v) => setSeasonEditForm((s) => ({ ...s, year: v }))}
        />
        <div className="actions">
          <button
            className="btn btn-primary"
            type="submit"
          >
            Save Changes
          </button>
          <button
            className="btn btn-muted"
            type="button"
            onClick={() => setView("season-detail")}
          >
            Cancel
          </button>
        </div>
      </form>
    </section>
  );
}

export default SeasonEditView;
